import { useState } from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import ClipLoader from 'react-spinners/ClipLoader';
import { Form } from 'rsuite';

const Help = () => {
	const [numPages, setNumPages] = useState(1);
	const [pageNumber, setPageNumber] = useState(1);

	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};

	const goToPrevPage = () =>
		setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

	const goToNextPage = () =>
		setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1);

	return (
		<Form layout="vertical" style={{textAlign: 'center'}}>
			<nav style={{ marginBottom: '2%' }}>
				<button onClick={goToPrevPage} style={{ marginRight: '2%' }}>Anterior</button>
				<button onClick={goToNextPage} style={{ marginBottom: '2%' }}>Siguiente</button>				
				<p>
					Página {pageNumber} de {numPages}
				</p>
			</nav>		
			<Document file="documents/Help.pdf" onLoadSuccess={onDocumentLoadSuccess} loading={<ClipLoader color={'#000000'} size={150} />}>
				<Page pageNumber={pageNumber}/>
			</Document>			
		</Form>
	);
};

export default Help;